import { menuDataResponse } from "../../LeftMenu/jsonMenu";

export function useRoles() {
  const name = JSON.parse(localStorage.getItem("state"));
  let userId = name?.userInfo?.id;
  let permissions = [];

  const roleName = name?.userInfo.roleList.map((item) => {
    item.moduleList.map((role) => {
      permissions.push(role);
      return role;
    });

    return { ...item.moduleList };
  });


  const menus = menuDataResponse?.menus
    .filter(function (menu) {
      if (
        menu?.code === "HV" || menu?.code === "VAC" ||
        (permissions?.some((x) => x?.code === menu?.code) && !menu?.subMenus)
      ) {
        return true;
      } else {
        return false;
      }
    })
    .map(function (menu, index) {
      return { ...menu, newOrder: index };
    });

  let subMenus = [];
  let indice = menus.length;
  const subMenus2 = menuDataResponse?.menus.map((menu) => {
    return menu?.subMenus?.map((sub, index) => {
      if (permissions.some((x) => x.code === sub?.code)) {
        subMenus.push({ ...sub, newOrder: indice });
        indice++;
        return sub;
      }
    });
  });

  const allMenus = [...menus, ...subMenus];

  allMenus.sort((a, b) => parseFloat(a.newOrder) - parseFloat(b.newOrder));

  const rolMenu = allMenus.map((menu) => {
    let permiso = permissions.find((element) => element.code === menu.code);
    return { ...menu, roleId: permiso.id };
  });

  return { rolMenu, userId };
}
